exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "p[data-v-4a83dc99]{margin:0}.no-results[data-v-4a83dc99]{padding:4px 16px}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/components/Search.vue"],"names":[],"mappings":"AACA,mBACE,QAAU,CACX,AACD,6BACE,gBAAkB,CACnB","file":"Search.vue","sourcesContent":["\np[data-v-4a83dc99] {\n  margin: 0;\n}\n.no-results[data-v-4a83dc99] {\n  padding: 4px 16px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4a83dc99","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Search.vue
// module id = 1418
// module chunks = 78